module.exports = __webpack_public_path__ + "img/msg1.24b10f98.png";